import { useEffect, useRef } from 'react';
import { scheduleMicrotask as scheduleMicrotaskUtility } from '@/lib/utils/scheduleMicrotask';
import { useAsyncCallback as useAsyncCallbackImpl, useEventCallback as useEventCallbackImpl, useStableCallback as useStableCallbackImpl } from './useStableCallback';
export const scheduleMicrotask: (callback: () => void) => void = scheduleMicrotaskUtility;
type BooleanReference = {
  current: boolean;
};
export function scheduleMicrotaskOnce(flagReference: BooleanReference, callback: () => void): void {
  if (flagReference.current) {
    return;
  }
  flagReference.current = true;
  scheduleMicrotask(() => {
    flagReference.current = false;
    callback();
  });
}
export function useUnmountEffect(callback: () => void): void {
  const callbackReference = useRef(callback);
  callbackReference.current = callback;
  useEffect(() => () => {
    callbackReference.current();
  }, []);
}
export function useAsyncCallback(...parameters: Parameters<typeof useAsyncCallbackImpl>) {
  return useAsyncCallbackImpl(...parameters);
}
export function useEventCallback(...parameters: Parameters<typeof useEventCallbackImpl>) {
  return useEventCallbackImpl(...parameters);
}
export function useStableCallback(...parameters: Parameters<typeof useStableCallbackImpl>) {
  return useStableCallbackImpl(...parameters);
}